<mat-sidenav-container class="bg-default" [class.isSmallScreen]="isSmallScreen" [class.smallHidden]="isSmallScreen">
  <mat-sidenav [mode]="isSmallScreen ? 'over' : 'side'" [opened]="isOpened" [fixedInViewport]="!isSmallScreen" (openedChange)="openChanged($event)">
    <app-sidebar [links]="links"></app-sidebar>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="open-nav-icon" *ngIf="isSmallScreen && !isOpened" (click)="openNavigation()">
      <img src="https://prysmaticlabs.com/assets/Prysm.svg" alt="company-logo">
    </div>
    <div class="pt-6 px-12 pb-10 bg-default min-h-screen">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
